import { Combobox, ComboboxCancel } from '@ariakit/react';
import { mdiClose, mdiMagnify } from '@mdi/js';
import { Icon } from '@mdi/react';
import React from 'react';
import { styled } from 'styled-components';

/** Magnifying glass icon displayed in search field */
const IconSearch = styled(Icon).attrs({ path: mdiMagnify })`
  color: #5f6b7c;
  position: absolute;
  width: 30px;
  height: 30px;
  padding: 3px;
`;

/** X icon for the clear search button */
const IconClose = styled(Icon).attrs({ path: mdiClose })`
  color: #5f6b7c;
  display: inline-block;
`;

/** Clear search button */
const CancelSearch = styled(ComboboxCancel)`
  position: absolute;
  right: 4px;
  width: 30px;
  height: 30px;
  background: none;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: rgb(143 153 168 / 15%);
  }
`;

/** Container for the search field input */
const SearchField = styled.div`
  padding: 4px;
  position: sticky;
  background-color: #fff;
  top: 0;
  z-index: 30;
`;

/** Input field for search */
const SearchFieldInput = styled(Combobox)`
  appearance: none;
  background: #fff;
  border: none;
  border-radius: 2px;
  box-shadow:
    0 0 0 0 rgb(45 114 210 / 0%),
    0 0 0 0 rgb(45 114 210 / 0%),
    inset 0 0 0 1px rgb(17 20 24 / 20%),
    inset 0 1px 1px rgb(17 20 24 / 50%);
  color: #1c2127;
  font-size: 12px;
  font-weight: 400;
  width: 100%;
  height: 30px;
  line-height: 30px;
  outline: none;
  padding: 0 30px;
  transition: box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9);
  vertical-align: middle;

  &::placeholder {
    color: #5f6b7c;
    opacity: 1;
  }

  &:focus {
    box-shadow:
      inset 0 0 0 1px #2d72d2,
      0 0 0 2px rgb(45 114 210 / 30%),
      inset 0 1px 1px rgb(17 20 24 / 20%);
  }
`;

/**
 * Search field for Combobox/Popover menus
 */
export default function ComboboxSearch() {
  return (
    <SearchField>
      <IconSearch />
      <SearchFieldInput
        autoSelect
        placeholder="Search..."
        /*
         * Ariakit's Combobox manually triggers a blur event on virtually
         * blurred items, making them work as if they had actual DOM
         * focus. These blur events might happen after the corresponding
         * focus events in the capture phase, leading Radix Select to
         * close the popover. This happens because Radix Select relies on
         * the order of these captured events to discern if the focus was
         * outside the element. Since we don't have access to the
         * onInteractOutside prop in the Radix SelectContent component to
         * stop this behavior, we can turn off Ariakit's behavior here.
         */
        onBlurCapture={(event) => {
          event.preventDefault();
          event.stopPropagation();
        }}
      />
      <CancelSearch hideWhenEmpty>
        <IconClose />
      </CancelSearch>
    </SearchField>
  );
}
